import { render } from "./MainSales.vue?vue&type=template&id=1c28be54&scoped=true"
import script from "./MainSales.vue?vue&type=script&lang=js"
export * from "./MainSales.vue?vue&type=script&lang=js"

import "./MainSales.vue?vue&type=style&index=0&id=1c28be54&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c28be54"]])

export default __exports__